import { ProductReviewForm as AdvoxProductReviewForm } from 'AdvoxComponent/ProductReviewForm/ProductReviewForm.component';
import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import { AUTHOR_ZAUFANE_PL } from 'Component/ProductReviewItem/ProductReviewItem.config';

/** @namespace Pwa/Component/ProductReviewForm/Component */
export class ProductReviewForm extends AdvoxProductReviewForm {
    renderReviewFormContent() {
        const { reviewData } = this.props;

        const { nickname = '', detail = '' } = reviewData;

        return (
            <div block="ProductReviewForm" elem="Wrapper">
                <div>{this.renderReviewRating()}</div>
                <div block="ProductReviewForm" elem="Content">
                    <Field
                        type={FIELD_TYPE.text}
                        attr={{
                            id: 'nickname',
                            name: 'nickname',
                            defaultValue: nickname,
                            placeholder: __('Your nickname'),
                        }}
                        validateOn={['onChange']}
                        validationRule={{
                            isRequired: true,
                            match: (value) => !(value.trim() === AUTHOR_ZAUFANE_PL),
                            customErrorMessages: {
                                onMatchFail: __('This nickname is not allowed'),
                            },
                        }}
                    />
                    <Field
                        type={FIELD_TYPE.textarea}
                        attr={{
                            id: 'detail',
                            name: 'detail',
                            defaultValue: detail,
                            placeholder: __('Review'),
                        }}
                        validateOn={['onChange']}
                        validationRule={{
                            isRequired: true,
                        }}
                    />
                </div>
            </div>
        );
    }

    renderReviewRating() {
        const { reviewRatings } = this.props;
        if (!reviewRatings || !reviewRatings?.length) {
            return null;
        }

        return reviewRatings.map(({ rating_id, rating_options }) => (
            <fieldset block="ProductReviewForm" elem="Rating" key={rating_id}>
                <span block="ProductReviewForm" elem="Legend">
                    {__('Rate')}
                </span>
                <div>
                    {rating_options
                        .sort(({ value }, { value: nextValue }) => nextValue - value)
                        .map((option) => this.renderReviewStar(option, rating_id))}
                </div>
            </fieldset>
        ));
    }
}

export default ProductReviewForm;
